
import {
    SET_LOADING,
    SET_LOADED
} from "../types";

export const pending = (is) => async (dispatch) => {
    try {
        dispatch({
            type: is ? SET_LOADING : SET_LOADED,
        });

        return true;
    } catch (error) {
        
    }
    return false;
}